'use client'
import { Link } from '@/app/i18n/navigation'
import { AlertCircle, ArrowLeft } from 'lucide-react'
import { useTranslations } from 'next-intl'

export default function ArticleError({
  errorMessage,
  displayButton,
}: {
  errorMessage: string
  displayButton: boolean
}) {
  const t = useTranslations('Blog')

  return (
    <div className={`flex items-center justify-center px-6 py-16 ${displayButton ? 'min-h-[70vh]' : ''}`}>
      <div className="max-w-md w-full text-center">
        <div className="relative mb-8 flex justify-center">
          <div className="absolute inset-0 m-auto w-24 h-24 rounded-full bg-[#B91C1C]/15 blur-3xl scale-150" aria-hidden="true" />
          <div className="relative p-5 rounded-full bg-white border-2 border-dashed border-[#B91C1C]/40 animate-float">
            <AlertCircle className="w-11 h-11 text-[#B91C1C]" />
          </div>
        </div>

        <h1 className="text-[#064E3B] text-2xl md:text-3xl font-bold mb-3">{t('error_title')}</h1>
        <p className="text-[#064E3B]/70 text-lg mb-8">{errorMessage}</p>

        {displayButton && (
          <Link
            href="/blog"
            className="inline-flex items-center justify-center gap-2 bg-[#FFE37B] hover:bg-[#FACC15] text-[#064E3B] font-bold py-3 px-6 rounded-full transition-colors">
            <ArrowLeft size={18} />
            {t('back_to_blog')}
          </Link>
        )}
      </div>
    </div>
  )
}
